import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Checkbox, useMantineTheme } from "@mantine/core";
const CheckboxConfirm = ({ labelPosition = "right", radius = 4, ...rest }) => {
    const theme = useMantineTheme();
    return (_jsx(Checkbox, { labelPosition: labelPosition, radius: radius, styles: {
            input: {
                "&:checked": {
                    backgroundColor: theme.colors.secondaryButton[2],
                    border: `1px solid ${theme.colors.divider[0]}`,
                },
                "&:not(checked)": {
                    border: `1px solid ${theme.colors.divider[0]}`,
                },
                "&:checked+.mantine-Checkbox-icon": {
                    color: theme.colors.primaryText[0],
                },
            },
        }, ...rest }));
};
export default CheckboxConfirm;
